import type { SVGProps } from 'react';

/**
 * The Binary wordmark, lifted from the header on binary.ax.
 *
 * The site hard-codes the fill (white when the logo tile is active, #FF4628
 * when it isn't). Here it inherits `currentColor` instead, so the same file
 * works white on the red tile and red anywhere else.
 */
const BinaryWordmark = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="90"
        height="34"
        viewBox="0 0 90 34"
        fill="none"
        role="img"
        aria-label="Binary"
        {...props}
    >
        <g clipPath="url(#biki-binary-wordmark)">
            <path
                d="M22.8105 3.90045C23.8287 3.90045 24.6385 4.7525 24.6385 5.79098C24.6385 6.82947 23.8287 7.62755 22.8105 7.62755C21.7922 7.62755 20.9824 6.80167 20.9824 5.79098C20.9824 4.7803 21.7922 3.90045 22.8105 3.90045Z"
                fill="currentColor"
            />
            <path d="M24.3152 9.61937H21.3086V25.8066H24.3152V9.61937Z" fill="currentColor" />
            <path
                d="M27.9313 9.61955H30.9732V12.1414C31.9177 10.1805 33.8403 9.07823 36.6016 9.07823C38.6285 9.07823 40.2721 9.90411 41.3208 11.3318C42.1947 12.5437 42.5443 14.0057 42.5443 16.2528V25.8085H39.5024V17.216C39.5024 14.2216 38.4184 11.9386 35.516 11.9386C32.4052 11.9386 30.9716 14.5765 30.9716 17.4646V25.8085H27.9297V9.61955H27.9313Z"
                fill="currentColor"
            />
            <path
                d="M58.3275 17.7114C58.3275 14.6091 56.2301 11.9711 52.9781 11.9711C49.7261 11.9711 47.6287 14.6091 47.6287 17.7114C47.6287 20.8138 49.7261 23.4174 52.9781 23.4174C56.2301 23.4174 58.3275 20.8138 58.3275 17.7114ZM61.3341 9.61943V25.8067H58.3275V22.9905C57.3493 24.8451 55.3209 26.1992 52.5932 26.1992C47.9783 26.1992 44.6221 22.2775 44.6221 17.7131C44.6221 13.1486 48.0136 9.19095 52.6285 9.19095C55.3209 9.19095 57.3477 10.5451 58.3275 12.3996V9.61943H61.3341Z"
                fill="currentColor"
            />
            <path
                d="M86.9565 9.61947V17.9273C86.9565 20.8515 85.5935 23.4534 82.3768 23.4534C79.3349 23.4534 78.4257 21.136 78.4257 18.1056V9.61947H75.3838V19.0672C75.3838 21.4566 75.6981 22.917 76.572 24.1304C77.5518 25.4502 79.1232 26.3955 81.2912 26.3955C84.1231 26.3955 85.9751 25.5075 86.9549 23.5106V25.1706C86.9549 28.95 85.4524 30.412 82.4794 30.412C80.0918 30.412 78.8218 29.4488 78.2974 27.9164L75.735 29.4259C76.7356 31.668 78.8603 33.1579 82.5147 33.1579C86.9357 33.1579 89.9214 30.9632 89.9936 25.375H89.9968V9.61947H86.9549H86.9565Z"
                fill="currentColor"
            />
            <path
                d="M74.0764 9.41668C73.8519 9.3856 73.6194 9.36761 73.3853 9.36761C71.0778 9.36761 68.9099 10.7577 68.0712 12.7905V9.61783H65.0293V25.8051H68.0712V18.7091C68.0712 14.8233 69.7838 12.2917 73.4559 12.2917C73.6659 12.2917 73.8584 12.2999 74.0764 12.3277V9.41668Z"
                fill="currentColor"
            />
            <path
                d="M17.3262 12.1969C17.6533 11.1682 17.8265 10.0218 17.8265 8.7756C17.8265 3.27736 14.5441 0 9.01988 0H0V10.6907H8.7537C10.8239 10.6907 12.5942 11.3481 13.7551 12.5943C12.7577 14.1545 11.066 15.0719 8.82586 15.0719H0V25.7331H8.99583C14.4719 25.7331 18.3188 22.042 18.3188 16.5193C18.3188 14.8462 17.9676 13.4022 17.3262 12.1969ZM9.01988 7.9579H3.16698V2.93556H8.7537C12.4691 2.93556 14.7814 4.83427 14.7814 8.67747C14.7814 8.93587 14.7702 9.18772 14.7509 9.43467C13.2195 8.46487 11.2648 7.95953 9.01988 7.95953M8.82586 22.7861H3.16698V17.8619H8.99583C11.5551 17.8619 13.6509 17.0835 15.1566 15.6901C15.1967 15.9959 15.2192 16.3148 15.2192 16.6485C15.2192 20.4917 12.5653 22.7861 8.82746 22.7861"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="biki-binary-wordmark">
                <rect width="90" height="33.1579" fill="#fff" />
            </clipPath>
        </defs>
    </svg>
);

export default BinaryWordmark;
